// extracted by mini-css-extract-plugin
export var wrapper = "google-map-module--wrapper--PAnap";